module.exports = new __parcel__URL__("clayofhope.086098a7.jpeg").toString();